/**
 * 描述：租户管理--所有用户
 * 日期：2017-9-27
 * 作者：liu_jinming
 */
'use strict';
angular.module('allTenantManageModule', ['tManageMentServiceModule', 'checkNameRepeatedModule', 'tenantDataConfigModule', 'allTenantManageRouterModule', 'xhsgConfigModule', ])
    .controller('allTenantManageCtrl', ['$scope', 'trsspliceString', '$q', '$filter', 'tManageMentService', 'modalDialog', 'trsHttpService', '$state', function($scope, trsspliceString, $q, $filter, tManageMentService, modalDialog, trsHttpService, $state) {
        initStatus();
        initData();

        /**
         * [initStatus description]初始化状态
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.status = {

            };
            $scope.params = {
                'serviceid': 'mlf_tenant',
                'methodName': 'queryTenants',
            };
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20,
                PAGECOUNT: 0,
                ITEMCOUNT: 0,
            };
            $scope.data = {
                selectedArray: [],
                tenants: [],
            };
        }

        /**
         * [initData description]初始化数据
         *
         * @return  {[type]}  [return description]
         */
        function initData() {
            initDropDownList();
            requestData();
        }
        
        /**
         * [initDropDownList description]初始化下拉菜单
         *
         * @return  {[type]}  [return description]
         */
        function initDropDownList() {
            $scope.status.statusList = [{ name: '全部', }, { name: '已启用', value: 0, }, { name: '已停用', value: 1, }, ];
            $scope.status.selectedStatus = angular.copy($scope.status.statusList[0]);
            $scope.status.searchType = [
                { name: '检索条件', value: 'SEARCHVALUE', },
                { name: '租户ID', value: 'TENANTID', },
                { name: '租户名称', value: 'TENANTNAME', },
                { name: '简介', value: 'ABBREVIATION', },
                { name: '描述', value: 'DESCRIPTION', },
                { name: '机构代码', value: 'ORGCODE', },
                { name: '备注', value: 'MEMO', },
            ];

            // 选中第一个 copy复刻
            $scope.status.selectedSearchType = angular.copy($scope.status.searchType[0]);
            getTenantType().then(function(data) {
                $scope.status.tenantType = data;
                $scope.status.selectedTenantType = angular.copy($scope.status.tenantType[0]);
            });
        }

        /**
         * [createUser description]新建
         */

        $scope.TenantNewUser = function() {
            tManageMentService.tenantCreate().then(function(params) {
                var BillingModules = angular.copy(params.BillingModules);
                delete params.BillingModules;
                params.serviceid = 'mlf_tenant';
                params.methodname = 'initTenantGrpUser';
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    BillingModules.forEach((item) => {
                        item.TenantId = data.TENANTID;
                    });
                    saveBillingModuleOfTenant(BillingModules, data.TENANTID);
                });
            }, function(data) {
                // 失败
            });
        };

        /**
         * [saveBillingModuleOfTenant description]新建之后，保存企业租户功能模块
         *
         * @param   {[type]}  BillingModules  [BillingModules description]
         * @param   {[type]}  TENANTID        [TENANTID description]
         *
         * @return  {[type]}                  [return description]
         */
        function saveBillingModuleOfTenant(BillingModules, TENANTID) {
            var par = {
                serviceid: 'mlf_billing',
                methodname: 'saveBillingModuleOfTenant',
                BillingModules: JSON.stringify(BillingModules),
                TenantId: TENANTID,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), par, 'POST').then(function(data) {
                modalDialog.alertType('新建租户成功', '', 'success', false);
                $scope.page.CURRPAGE = 1;
                requestData();
            });
        }

        /**
         * [TenantDisable description]停用
         *
         * @return  {[type]}  [return description]
         */
        $scope.TenantDisable = function() {
            var ids = trsspliceString.spliceString($scope.data.selectedArray, 'TENANTID', ',', 'STATUS', '0');
            disable(ids);
        };

        /**
         * [disable description]停用租户
         *
         * @param   {[type]}  ids  [ids description] id串
         *
         * @return  {[type]}       [return description]
         */
        function disable(ids) {
            if (!ids) {
                modalDialog.alertType('', '您选择的租户已停用', 'warning', false);
                return;
            }
            modalDialog.alertType('', '确定停用？', 'ask', true, function() {
                var params = {
                    serviceid: 'mlf_tenant',
                    methodname: 'deactivateTenant',
                    ObjectIds: ids,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    modalDialog.multiReportsAlert(data, function() {
                        $scope.page.CURRPAGE = 1;
                        requestData();
                    });
                });
            });
        }

        /**
         * [getTenantType description]企业类型初始化下拉菜单
         *
         * @return  {[type]}  [return description]
         */
        function getTenantType() {
            var deffer = $q.defer();
            var params = {
                serviceid: 'mlf_tenant',
                methodname: 'findIndustryByConfig',
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                for (var i = 0; i < data.length; i++) {
                    data[i] = { name: data[i], value: data[i], };
                }
                data.unshift({ name: '全部', }); // 添加
                deffer.resolve(data);
            });
            return deffer.promise;
        }

        /**
         * [requestData description]tenant请求数据
         *
         * @return  {[type]}  [return description]
         */
        function requestData() {
            var defer = $q.defer();
            $scope.data.selectedArray = [];
            $scope.params.CURRPAGE = $scope.page.CURRPAGE;
            $scope.params.PAGESIZE = $scope.page.PAGESIZE;
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'post').then(function(data) {
                // tenant请求数据user
                $scope.data.tenants = data.DATA;
                $scope.page = data.PAGER;
                $scope.data.copyCurrPage = data.PAGER.CURRPAGE;
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [showTenantInfo description]
         * @param  {[type]} item [description] 点击租户的重要信息
         * @return {[type]}      [description]
         */
        $scope.showTenantInfo = function(item) {
            tManageMentService.showTenantInfo(item);
        };

        /**
         * [searchWord description]点击搜索
         *
         * @param   {[type]}  ev  [ev description]
         *
         * @return  {[type]}      [return description]
         */
        $scope.searchWord = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                var searchType;
                for (var i = 0; i < $scope.status.searchType.length; i++) {
                    searchType = $scope.status.searchType[i].value;
                    delete $scope.params[searchType];
                }
                $scope.params[$scope.status.selectedSearchType.value] = $scope.status.searchWord;
                requestData();
            }
        };

        /**
         * [hotWarning description]热点预警
         *
         * @param   {[type]}  item  [item description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.hotWarning = function(item) {
            tManageMentService.hotWarning(item).then(function() {
                modalDialog.alertType('', '热点信息修改成功!', 'success', false);
                requestData();
            });
        };

        /**
         * [resouceLimit description]资源使用限制
         *
         * @param   {[type]}  item  [item description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.resouceLimit = function(item) {
            tManageMentService.resouceLimit(item).then(function() {
                requestData();
            });

        };

        /**
         * [regionalOfficia description]地区相关官员
         *
         * @param   {[type]}  item  [item description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.regionalOfficia = function(item) {
            tManageMentService.listOfRngOfficials(item).then(function() {

            });

        };

        /**
         * [requestData description]tenant请求数据
         *
         * @return  {[type]}  [return description]
         */
        $scope.requestData = function() {
            requestData();
        };

        /**
         * [selectFilterType description]选中下拉菜单
         *
         * @param   {[type]}  attribute1  [attribute1 description]
         * @param   {[type]}  attribute2  [attribute2 description]
         *
         * @return  {[type]}              [return description]
         */
        $scope.selectFilterType = function(attribute1, attribute2) {
            $scope.params[attribute2] = $scope.status[attribute1].value;
            requestData();
        };

        // 点击服务项配置淡出关于租户服务项的相关信息
        $scope.servicesConfig = function(item) {
            tManageMentService.tenantServiceInfo(item);
        };

        // 点击设置租户的计费功能模块
        $scope.setBilling = function(item) {
            tManageMentService.setBilling(item);
        };

        // 点击传播力指数配置功能的相关信息
        $scope.settingTransmission = function(item) {
            tManageMentService.settingTransmission(item);
        };

        /**
         * [jumpToPage description]跳转到指定页
         *
         * @return  {[type]}  [return description] tenant
         */
        $scope.jumpToPage = function() {
            $scope.params.CURRPAGE = $scope.data.copyCurrPage;
            requestData();
        };

        /**
         * [selectItem description]选中租户
         *
         * @param   {[type]}  item  [item description]选中租户
         *
         * @return  {[type]}        [return description]
         */
        $scope.selectItem = function(item) {
            if ($scope.data.selectedArray.indexOf(item) < 0) {$scope.data.selectedArray.push(item);} else {$scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);}
        };

        /**
         * [selectAll description]全选租户
         *
         * @return  {[type]}  [return description]
         */
        $scope.selectAll = function() {
            $scope.data.selectedArray = $scope.data.selectedArray.length === $scope.data.tenants.length ? [] : (function() {
                var array = [];
                for (var i = 0; i < $scope.data.tenants.length; i++) {
                    array.push($scope.data.tenants[i]);
                }
                return array;
            })();
        };

        /**
         * [editTenant description] 选中租户
         *
         * @param   {[type]}  item  [item description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.editTenant = function(item) {
            $scope.data.fromDate = item.CRTIME;
            $scope.data.untilDate = item.ENDTIME;
            tManageMentService.editTenant(angular.copy(item)).then(function(data) {
                $scope.page.CURRPAGE = 1;
                requestData();
            });
        };

        /**
         * [tenantDataConfig description] 租户成品数据配置页面跳转
         * @param  {[type]} tenantId [description] 租户ID
         * @return {[type]}          [description]
         */
        $scope.tenantDataConfig = function(tenantId) {
            $state.go('manageconfig.tenantmanagement.allTenantManage.tenantDataConfig', { tenantid: tenantId, });
        };

        /*
             * [showEffectiveTime description] 显示模块生效时间
             * @param {[object]} [item] [description] 选中的租户
             */
        $scope.showEffectiveTime = function(item) {
            tManageMentService.effectiveTime(item);
        };

        /**
         * [xhsgConfig 新华社稿配置]
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.xhsgConfig = function(item){
            $state.go('manageconfig.tenantmanagement.allTenantManage.xhsgConfig', {
                tenantid: item.TENANTID,
            });
        };

    }, ]);
